import { Injectable, inject, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { AuthState } from '@app/modules/users';
import { ReferralsState } from '@app/modules/referrals';
import { listenWebsocketEvents } from '@core/websocket';

import { WsEvents } from '../event/battle.entity';
import { SideType } from '../users/users.entity';

import { MainApiResponse, MainBanner, MainLiveDrop } from './main.entity';
import { MainService } from './main.service';

@Injectable()
export class MainState {
  private readonly mainService = inject(MainService);
  private readonly authState = inject(AuthState);
  private readonly referralsState = inject(ReferralsState);

  public readonly banners = signal<MainBanner[]>([]);
  public readonly liveDrops = signal<MainLiveDrop[]>([]);
  public readonly tPoints = signal<number>(0);
  public readonly ctPoints = signal<number>(0);
  public readonly cardsCoins = signal<number>(0);

  private readonly wsEvents = listenWebsocketEvents({
    'live_drops.new': (data) => this.onWsNewLiveDrop(data)
  }, 'live_drops');

  fetchBanners(): Observable<MainApiResponse.Banners> {
    const marketingCode = this.authState.marketingCode();
    const refCode = this.referralsState.refCode();

    return this.mainService.getBanners(refCode, marketingCode).pipe(
      tap((response) => {
        this.banners.set(response.banners);
        this.tPoints.set(response.tPoints);
        this.ctPoints.set(response.ctPoints);
        this.cardsCoins.set(response.cardsCoins);
      })
    );
  }

  fetchLiveDrops(): Observable<MainApiResponse.LiveDrops> {
    return this.mainService.getLiveDrops().pipe(
      tap((response) => {
        this.liveDrops.set(response.liveDrops);
      })
    );
  }

  private onWsNewLiveDrop(liveDrop: MainLiveDrop): void {
    liveDrop.isAnimated = true;

    const liveDrops = this.liveDrops();

    liveDrops.unshift(liveDrop);
    liveDrops.splice(-1, 1);

    this.liveDrops.set([...liveDrops]);
  }

  private onWsUpdateSidePoints({ id, points }: WsEvents.UpdateSide): void {
    if(id === SideType.COUNTER_TERRORIST) {
      this.ctPoints.set(points);
    } else {
      this.tPoints.set(points);
    }
  }
}